import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import ErrorPage from 'next/error';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { getPosts, getCategoriess } from '../../../utils/api/wordpress-api';
import ArticlesSubHeader from '../../../components/Articles/SubHeader';
import ArticlesMain from '../../../components/Articles/Main';
import BlogSEO from '../../../components/SEO/ForBlog';
import { checkLocaleAllowed } from '../../blog';

interface Props {
  posts: any;
  categories: any[];
  pageContext: any;
}

function Index({ posts: { edges }, categories, pageContext }: Props) {
  const { t } = useTranslation('blog');
  const router = useRouter();
  const { locale } = router;

  if (!checkLocaleAllowed(locale)) {
    return <ErrorPage statusCode={404} />;
  }

  return (
    <>
      <BlogSEO title={t('title.author', { author: pageContext.author })} />
      <ArticlesSubHeader categories={categories} />
      <ArticlesMain locale={locale} posts={edges} pageContext={pageContext} />
    </>
  );
}

export async function getServerSideProps({
  preview = false,
  query,
  locale = 'en',
}) {
  const { author } = query;
  const posts = await getPosts(
    {
      offset: 0,
      author,
    },
    locale,
  );
  const categoriesData = await getCategoriess(locale);
  const basePath = '/blog/author/[author]';
  const baseAsPath = `/blog/author/${author}`;
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'blog'])),
      posts,
      preview,
      categories: categoriesData.categories,
      pageContext: {
        totalCount: posts.pageInfo.offsetPagination.total,
        limit: 10,
        skip: 0,
        filter: null,
        searchTerm: null,
        basePath,
        baseAsPath,
        author,
        locale,
      },
    },
  };
}

export default Index;
